function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 137.143h160V.357H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M11.174 1.26L4.231 2.337 1.266 6.64v6.629h52.671V6.64l-2.08-3.083-4.683-2.297z"
}), /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M9.737.297C4.36.297 0 3.566 0 8.926v59.828c0 .949.151 1.723 1.1 1.723.949 0 1.063-.774 1.063-1.723V8.926c0-4.415 2.726-6.309 7.594-6.309h36.809a6.305 6.305 0 0 1 6.308 6.309v3.285H9.606c-.946 0-1.723.206-1.723 1.152 0 .948.777 1.057 1.723 1.057h43.268v2.009c-.017.945.012 1.8.963 1.8.946 0 .986-.872.986-1.82V8.926c0-5.377-2.894-8.629-8.257-8.629H9.737z"
}), /*#__PURE__*/React.createElement("path", {
  id: "g",
  d: "M2.694 2.603v7.643l2.869 4.957 6.74 1.237h34.914l4.546-2.646 2.014-3.548V2.603z"
}), /*#__PURE__*/React.createElement("path", {
  id: "i",
  d: "M.394 2.743c0 .88.715 1.6 1.595 1.6a1.596 1.596 0 1 0 0-3.194c-.88 0-1.595.711-1.595 1.594z"
}), /*#__PURE__*/React.createElement("path", {
  id: "k",
  d: "M52.686 3.054v15.763c0 3.314-2.523 7.986-6.137 7.986H9.737c-3.468 0-6.628-4.443-6.628-7.986V15.16h41.98c.945 0 1.814-.166 1.814-1.114 0-.946-.869-.986-1.814-.986H2.75c-.948 0-1.725.3-1.725 1.249v4.488c0 5.552 4.857 10.194 8.711 10.194H46.55c4.448 0 8.308-4.594 8.308-10.174V3.054c0-.948-.131-1.723-1.08-1.723-.943 0-1.091.775-1.091 1.723z"
}), /*#__PURE__*/React.createElement("path", {
  id: "m",
  d: "M6.586 1.54c-2.677 0-4.849 2.077-4.849 4.634v26.869c0 2.557 2.172 4.631 4.849 4.631h1.623l.048 9.637 11.6-9.637h23.866c2.677 0 4.848-2.074 4.848-4.631V6.174c0-2.557-2.171-4.634-4.848-4.634H6.586z"
}), /*#__PURE__*/React.createElement("path", {
  id: "o",
  d: "M4.931.106C2.374.106.303 2.034.303 4.414V29.41c0 2.38 2.071 4.308 4.628 4.308H6.48l.043 8.966 11.071-8.966H40.38c2.554 0 4.629-1.928 4.629-4.308V4.414c0-2.38-2.075-4.308-4.629-4.308H4.931z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 12.5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8F9FF",
  d: "M6.666 61.071h26.668c3.666 0 6.666-3 6.666-6.665 0-3.669-3-6.669-6.666-6.669H6.666C3 47.737 0 44.737 0 41.071c0-3.665 3-6.665 6.666-6.665H140c3.666 0 6.666 3 6.666 6.665 0 3.666-3 6.666-6.666 6.666h-26.666c-3.665 0-6.668 3-6.668 6.669 0 3.665 3.003 6.665 6.668 6.665H150c3.666 0 6.666 3 6.666 6.666 0 3.666-3 6.669-6.666 6.669h-28.334c-2.749 0-5 2.248-5 5 0 2.748 2.251 5 5 5h31.668c3.666 0 6.666 3 6.666 6.665 0 3.666-3 6.666-6.666 6.666h-140c-3.665 0-6.668-3-6.668-6.666 0-3.665 3.003-6.665 6.668-6.665H45c2.751 0 5-2.252 5-5 0-2.752-2.249-5-5-5H6.666C3 74.406 0 71.403 0 67.737c0-3.666 3-6.666 6.666-6.666"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M132.857 100.488a1.43 1.43 0 0 1-1.428 1.429 1.43 1.43 0 1 1 1.429-1.429"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E3E9FD",
  strokeWidth: 1.607,
  d: "M24.286 131.786A4.287 4.287 0 0 1 20 136.07a4.287 4.287 0 0 1-4.286-4.285A4.287 4.287 0 0 1 20 127.5a4.287 4.287 0 0 1 4.286 4.286z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E3E9FD",
  strokeLinecap: "round",
  strokeWidth: 1.607,
  d: "M24.35 105.946h8.571m-4.285 4.286v-8.572M130 22.5h8.571m-4.285 4.286v-8.572"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M134.286 3.214a2.855 2.855 0 0 1-2.857 2.857 2.855 2.855 0 0 1-2.858-2.857A2.855 2.855 0 0 1 131.43.357a2.855 2.855 0 0 1 2.857 2.857"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E3E9FD",
  strokeLinejoin: "round",
  strokeWidth: 1.071,
  d: "M21.429 6.786v1.428-2.857zm0 8.571v1.429-2.857zm-4.286-4.286h1.428-2.857zm8.571 0h1.429-2.857zm-1.255-3.03l-1.012 1.012L24.46 8.04l1.01-1.01zm-6.06 6.06l-1.012 1.012L18.4 14.1l1.011-1.011zm0-6.06l1.011 1.012-1.011-1.012-1.012-1.011zm6.06 6.06l1.011 1.012-1.011-1.012-1.012-1.011zM130 124.766v1.428-2.857zm0 8.571v1.429-2.857zm-4.286-4.286h1.429-2.857zm8.572 0h1.428-2.857zm-1.256-3.03l-1.011 1.012 1.011-1.012 1.011-1.011zm-6.06 6.06l-1.011 1.012 1.011-1.012 1.011-1.011zm0-6.06l1.011 1.012-1.011-1.012-1.011-1.011zm6.06 6.06l1.011 1.012-1.011-1.012-1.011-1.011z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M47.22 99.643h52.191V36.129H47.22z",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(45.714 35.357)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.054 18.591h63.311V-4.06H-4.054z",
  mask: "url(#d)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M88.853 48.837h10.64V41.47l-4.783-5.272-5.857.42z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(45.714 35.357)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE1FD",
  d: "M-5.32 75.8h65.469V-5.029H-5.32z",
  mask: "url(#f)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(45.714 109.643)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-2.631 21.763h61.728v-24.48H-2.63z",
  mask: "url(#h)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M73.418 119.699c.883 0 1.6-.718 1.6-1.6a1.598 1.598 0 1 0-1.6 1.6"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(71.429 115.357)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M-4.929 9.663H8.91V-4.174H-4.93z",
  mask: "url(#j)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M88.853 112.246h10.64v7.366l-4.783 5.271-5.857 1.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE1FD",
  d: "M100.572 117.031v-15.763c0-.948-.131-1.723-1.08-1.723-.946 0-1.091.775-1.091 1.723v15.763c0 3.314-2.523 7.986-6.138 7.986H55.452c-3.469 0-6.629-4.443-6.629-7.986v-3.654h41.98c.946 0 1.815-.169 1.815-1.117 0-.946-.869-.986-1.815-.986H48.466c-.948 0-1.725.303-1.725 1.249v4.488c0 5.554 4.854 10.194 8.711 10.194h36.811c4.446 0 8.309-4.594 8.309-10.174"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(45.714 98.214)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#k"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.607,
  d: "M-4.297 34.314h64.474V-3.989H-4.297z",
  mask: "url(#l)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M60.684 98.348a1.314 1.314 0 0 1-1.855-.154 1.318 1.318 0 0 1 .169-1.854l15.817-14.13a1.319 1.319 0 0 1 1.834.172 1.32 1.32 0 0 1-.148 1.84L60.684 98.348zm3.194-15.965c-.56.468-1.388.4-1.854-.154a1.316 1.316 0 0 1 .169-1.855l10.494-8.805a1.317 1.317 0 0 1 1.834.171c.46.546.392 1.363-.148 1.837l-10.495 8.806z",
  fill: "#DAE1FD"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(82.857 55.357)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#m"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E3E9FD",
  d: "M-3.586 52.631h57.477V-3.78H-3.586z",
  mask: "url(#n)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.607,
  d: "M126.58 56.897H89.441c-2.677 0-4.846 2.078-4.846 4.635v26.865c0 2.56 2.169 4.632 4.846 4.632h1.623l.048 9.64 11.598-9.64h23.868c2.677 0 4.849-2.072 4.849-4.632V61.532c0-2.557-2.172-4.635-4.849-4.635"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(85.357 57.857)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "p",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#o"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-5.02 48.003h55.349v-53.22H-5.02z",
  mask: "url(#p)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DAE1FD",
  d: "M108.75 81.25a2.499 2.499 0 1 1 0 5 2.499 2.499 0 1 1 0-5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DAE1FD",
  strokeLinecap: "round",
  strokeWidth: 2.813,
  d: "M108.75 77.5V65"
}));

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.abdcb2b2.svg";
export { ForwardRef as ReactComponent };